module.exports = __webpack_public_path__ + "img/198.9635cdd0.jpg";